import React, { useContext, useEffect, useRef, useState } from "react";
import { AppState } from "../App";
import { message } from "antd";
import { useTimer } from "react-timer-hook";
import { TailSpin } from "react-loader-spinner";
import { ethers } from "ethers";
import moment from "moment";
import { useWeb3 } from "../contexts/Web3Context";

function MyTimer({ expiryTimestamp }) {
  const { seconds, minutes, hours, days } = useTimer({ expiryTimestamp });

  return (
    <p>
      <span>{days} Days, </span>
      <span>{hours.toString().padStart(2, "0")}</span>:
      <span>{minutes.toString().padStart(2, "0")}</span>:
      <span>{seconds.toString().padStart(2, "0")}</span>
    </p>
  );
}

const UserInfo = () => {
  const useAppState = useContext(AppState);
  const intervalRef = useRef();
  const { staticContract, walletAddress, isContractReady, isWalletConnected } =
    useWeb3(); // Add this
  const [user, setUser] = useState({
    start: 0,
    level: 0,
    directTeam: 0,
    directRequired: 2,
    referrer: "",
  });
  const [time, setTime] = useState(0);
  const [showTimer, setShowTimer] = useState(false);
  const [loading, setLoading] = useState(true); // Add loading state
  const [error, setError] = useState(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (Number(user.start) > 0) {
        setTime(Date.now() - Number(user.start));
      } else {
        setTime(0);
      }
    }, 10);
    return () => clearInterval(intervalRef.current);
  }, [user.start]);

  useEffect(() => {
    let mounted = true;
    async function getData() {
      try {
        if (!isContractReady || !isWalletConnected) {
          //console.log("Initialization status:", {
          //  isContractReady,
          //  isWalletConnected,
          //  hasContract: !!staticContract,
          //  hasWallet: !!walletAddress,
          //});
          return;
        }
        setShowTimer(false);
        setLoading(true);
        //console.log("Getting user info for ID:", useAppState.id);
        const userId = ethers.getBigInt(useAppState.id.toString());
        const _user = await staticContract.userInfo(userId);
        //console.log("User info fetched:", _user);
        if (mounted) {
          setUser({
            start: Number(_user[4]) * 1000,
            level: Number(_user[5]),
            directTeam: Number(_user[6]),
            directRequired: 2,
            referrer: Number(_user[2]),
          });
          setShowTimer(true);
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
        if (mounted) {
          setError(error.message);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    }
    getData();
    return () => {
      mounted = false;
    };
  }, [isContractReady, isWalletConnected, staticContract, useAppState.id]);

  if (loading) {
    return (
      <div className="w-full flex justify-center items-center p-4">
        <TailSpin height={30} color="#4B5563" />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="w-full transition-colors duration-1000 flex flex-col items-start bg-opacity-40 dark:bg-opacity-40 bg-white dark:bg-[#1e2026] shadow-lg p-3 rounded-sm">
      <div className="flex w-full flex-col items-start font-mono rounded-sm text-white text-sm font-semibold whitespace-nowrap max-w-full overflow-x-auto">
        <span className="text-sm text-black bg-gray-200 py-1 px-2">
          {walletAddress
            ? `${walletAddress.slice(
                0,
                9
              )}...${walletAddress.slice(36)}`
            : "Connect Wallet"}
        </span>
        <div className="py-2 px-2 mt-2 rounded-sm bg-blue-500 text-white">
          My Wallet Fund:{" "}
          <span className="bg-gray-200 text-black py-[6px] px-2">
            {useAppState.bal ? useAppState.bal.toFixed(5) : "0.00000"} BNB
          </span>
        </div>
      </div>

      <div className="flex items-center justify-start">
        <div className="flex flex-col items-start">
          <span className="flex justify-center items-center text-sm font-medium mt-3">
            User ID{" "}
          </span>
          <span className="flex justify-center items-center text-sm font-medium mt-3">
            Rank{" "}
          </span>
          {showTimer ? (
            <span className="flex justify-center items-center text-sm font-medium mt-3">
              Activation Date
            </span>
          ) : null}
          <span className="flex justify-center items-center text-sm font-medium mt-3">
            Referred By
          </span>
        </div>
        <div className="flex flex-col items-start ml-3">
          <span
            className={`bg-gray-200 mt-3 text-sm font-medium rounded-xl px-3 text-gray-800`}
          >
            {useAppState.id || "N/A"}
          </span>
          <span
            className={`bg-gray-200 mt-3 text-sm font-medium rounded-xl px-3 text-gray-800`}
          >
            {useAppState.ranks && user.level
              ? useAppState.ranks[user.level - 1]
              : "N/A"}
          </span>
          <span className="bg-gray-200 mt-3 text-sm font-medium rounded-xl px-3 text-gray-800">
            {useAppState.getUTCTime(user.start)}
          </span>
          <span
            className={`bg-gray-200 mt-3 text-sm font-medium rounded-xl px-3 text-gray-800`}
          >
            {user.referrer == "17534"
              ? "Default Refer"
              : user.referrer || "N/A"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
